module.exports = __webpack_public_path__ + "static/fabric-datepicker-disabled-datetime-5f0aae3a214fe56a70ccfb4d11b588d0.png";